<template>
  <div>
    <div>
      <b-card-actions
        title="Filters"
        action-collapse
        collapsed
      >
        <b-row>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Device Name"
              label-for="v-name"
            >
              <b-form-input
                id="v-name"
                v-model="filters['name']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Device IP"
              label-for="device_ip"
            >
              <b-form-input
                id="device_ip"
                v-model="filters['device_ip']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Assigned Bucket"
              label-for="v-ref-no"
            >
              <v-select
                id="v-ref-no"
                v-model="filters['node.id']"
                :options="branchOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Bucket"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Is Assigned"
              label-for="v-is-assigned"
            >
              <v-select
                id="v-is-assigned"
                v-model="filters['is_assigned']"
                :options="assignedOptions"
                :reduce="option => option.key"
                label="name"
                placeholder="Select Status"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1">
          <b-col>
            <filter-buttons
              :filter-data="filters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </b-card-actions>
    </div>
    <div>
      <b-card
        no-body
      >
        <div>
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <div
              class="m-2"
            >
              <!-- input -->
              <b-row>
                <b-col
                  md="7"
                  class="d-flex align-items-center justify-content-start mb-1 mt-1 mb-md-0"
                >
                  <b-button
                    v-can="'sorting-device-create'"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    class="custom-button-color"
                    @click="onClickCreateSortingDevice"
                  >
                    <feather-icon icon="PlusIcon" />
                    Add New
                  </b-button>
                </b-col>
                <b-col
                  class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
                >
                  <ReportTableButtons
                    class="mt-2"
                    :items="rows"
                    :json_fieldz="json_fields"
                    :name="`SortingDevices - Page ${page}.xls`"
                    :bulkname="`SortingDevices.xls`"
                    :fetch="fetchSortingDevicesNoPagination"
                    @refresh="onClickRefresh"
                  />
                </b-col>
              </b-row>
            </div>
            <!-- table -->
            <b-table
              :per-page="perPage"
              :items="rows"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              hover
              responsive
              striped
              show-empty
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #cell(is_assigned)="data">
                <div>
                  <b-badge :variant="`light-${data.value?'success':'danger'}`">
                    {{ data.value ? 'Yes' : 'No' }}
                  </b-badge>
                </div>
              </template>
              <template #cell(node)="data">
                <div
                  class="font-weight-bold"
                >
                  {{ data.value ? data.value.name : 'N/A' }}
                </div>
              </template>
              <template #cell(parent_bucket)="data">
                <div
                  class="font-weight-bold"
                >
                  {{ data.item.node ? data.item.node.key.split('_')[1] : 'N/A' }}
                </div>
              </template>
              <template #cell(user)="data">
                <div
                  v-if="data.value"
                  class="d-flex align-items-center"
                >
                  <div>
                    <div class="font-weight-bold">
                      {{ data.value.first_name }} {{ data.value.last_name }}
                    </div>
                    <small>{{ data.value.roles[0].name }}</small>
                  </div>
                </div>
                <div
                  v-else
                  class="font-weight-bold"
                >
                  {{ '---' }}
                </div>
              </template>
              <template #cell(updated_at)="data">
                <div
                  class="font-weight-bold"
                >
                  {{ data.value ? __dateTimeFormatter(data.value) : '---' }}
                </div>
              </template>
              <template #cell(action)="data">
                {{ data.value }}
                <b-dropdown
                  no-caret
                  toggle-class="text-decoration-none"
                  variant="link"
                >
                  <template v-slot:button-content>
                    <feather-icon
                      class="text-body align-middle mr-25"
                      icon="MoreVerticalIcon"
                      size="12"
                    />
                  </template>
                  <b-dropdown-item
                    v-can="'sorting-device-edit'"
                    @click="onClickEditDevice(data.item.id)"
                  >
                    <feather-icon icon="ToolIcon" />
                    Edit Device
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="data.item.is_assigned"
                    v-can="'sorting-device-edit'"
                    @click="unlinkDevice(data.item.id)"
                  >
                    <feather-icon icon="XIcon" />
                    Unlink Device
                  </b-dropdown-item>
                </b-dropdown>
              </template>

            </b-table>
            <div class="mx-2 mb-2">
              <b-row>

                <b-col
                  class="d-flex align-items-center justify-content-sm-start"
                  cols="12"
                  md="3"
                >
                  <label class="width-75">Per page</label>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block ml-1 width-100 mr-2"
                  />
                </b-col>
                <!-- Pagination -->
                <b-col
                  class="d-flex align-items-center justify-content-sm-end"
                  cols="12"
                  md="9"
                >
                  <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                  <b-pagination
                    v-model="page"
                    :per-page="perPage"
                    :total-rows="(meta.total)? meta.total : 0"
                    class="mb-0 mt-1 mt-sm-0"
                    first-number
                    last-number
                    next-class="next-item"
                    prev-class="prev-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>

              </b-row>
            </div>
          </b-overlay>

        </div>
      </b-card>
    </div>
    <set-sorting-device ref="set_sorting_device" />
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BPagination,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BDropdown,
  BDropdownItem,
  BBadge,
  VBTooltip,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import vSelect from 'vue-select'
import { avatarText } from '@core/utils/filter'
import SetSortingDevice from '@/components/Sorting/SetSortingDeviceModal.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import store from '@/store/index'
import FilterButtons from '@/components/Filter/FilterButtons.vue'

const sortingRepository = RepositoryFactory.get('sorting')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BCardActions,
    BPagination,
    BFormGroup,
    BFormInput,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BOverlay,
    vSelect,
    BDropdown,
    BDropdownItem,
    BBadge,
    SetSortingDevice,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage],
  data() {
    return {
      avatarText,
      filters: {},
      branchOptions: [],
      total: 0,
      meta: {},
      dataLoading: false,
      // Start BS Table
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      // End BS Table
      pageLength: 20,
      dir: false,
      fields: [
        {
          key: 'name',
          label: 'Device Name',
          sortable: true,
          tdClass: 'text-left',
        },
        {
          key: 'device_ip',
          label: 'Device IP',
          sortable: true,
        },
        {
          key: 'is_assigned',
          label: 'Is Assigned',
          sortable: true,
        },
        {
          key: 'node',
          label: 'Assigned Bucket',
          sortable: true,
        },
        {
          key: 'parent_bucket',
          label: 'Parent Bucket',
          sortable: true,
        },
        {
          key: 'user',
          label: 'Updated By',
          sortable: true,
        },
        {
          key: 'updated_at',
          label: 'Updated At',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
        },
      ],
      json_fields: {
        'Device Name': {
          field: 'name',
          callback: value => `"${value}"`,
        },
        'Device IP': {
          field: 'device_ip',
          callback: value => `"${value}"`,
        },
        'Is Assigned': {
          field: 'is_assigned',
          callback: value => (value ? 'Yes' : 'No'),
        },
        'Assigned Bucket': {
          field: 'node',
          callback: value => `"${value && value.name ? value.name : 'N/A'}"`,
        },
        'Parent Bucket': {
          field: 'node',
          callback: value => `"${value && value.key ? value.key.split('_')[1] : 'N/A'}"`,
        },
        'Updated By': {
          field: 'user',
          callback: value => `"${value !== null ? `${value.first_name}` : 'N/A'} ${value !== null && value.last_name !== null ? `${value.last_name}` : ''}"`,
        },
        'Updated At': {
          field: 'updated_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
      },
      rows: [],
      assignedOptions: [
        {
          name: 'Yes',
          key: 'true',
        },
        {
          name: 'No',
          key: 'false',
        },
      ],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchSortingDevices()
      },
    },
    deep: true,
    page() {
      this.fetchSortingDevices()
    },
    perPage() {
      this.fetchSortingDevices()
    },
  },
  mounted() {
    this.fetchSortingDevices()
    this.getBranchList()
  },
  methods: {
    async fetchSortingDevices() {
      this.dataLoading = true
      this.rows = []
      try {
        const { data } = (await sortingRepository.getSortingDevices(this.page, this.perPage, this.filterQuery))
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchSortingDevicesNoPagination() {
      try {
        const { data } = (await sortingRepository.getSortingDevicesNoPagination(this.filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async getBranchList() {
      try {
        this.branchOptions = (await sortingRepository.getSortingBranches()).data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async unlinkDevice(id) {
      return this.$swal({
        title: 'Are you sure',
        icon: 'info',
        text: 'Are you sure you want to unlink this device?',
        showCancelButton: true,
        confirmButtonText: 'Yes, confirm!',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        backdrop: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.deviceUnlink(id)
        }
      })
    },
    async deviceUnlink(id) {
      try {
        const res = await sortingRepository.unlinkDevice(id)
        if (res.status === 200) {
          this.showSuccessMessage('Device Unlinked Successfully')
          this.onClickRefresh()
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onClickCreateSortingDevice() {
      this.$refs.set_sorting_device.openModal(null, 'add')
    },
    onClickEditDevice(id) {
      this.$refs.set_sorting_device.openModal(id, 'edit')
    },
    changePage(value) {
      this.perPage = value
    },
    handleChangePage(page) {
      this.page = page
      this.fetchSortingDevices()
    },
    applyFilters() {
      this.fetchSortingDevices()
    },
    clearFilters() {
      this.filters = {}
      this.$nextTick(() => {
        this.fetchSortingDevices()
      })
    },
    onClickRefresh() {
      this.fetchSortingDevices()
    },
  },
}
</script>
<style lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/required.scss';
</style>
